import { useCallback, useEffect, useRef } from 'react'

export function removeOverlayHistoryMarker(marker: string) {
  if (typeof window === 'undefined') return
  const state = window.history.state
  if (!state?.[marker]) return

  const rest = { ...(state as Record<string, unknown>) }
  delete rest[marker]
  window.history.replaceState(Object.keys(rest).length > 0 ? rest : null, '', window.location.href)
}

export function useOverlayHistoryDismiss(open: boolean, onDismiss: () => void, marker: string) {
  const onDismissRef = useRef(onDismiss)
  const pushedRef = useRef(false)

  useEffect(() => {
    onDismissRef.current = onDismiss
  }, [onDismiss])

  useEffect(() => {
    if (!open || typeof window === 'undefined') return

    const currentState = window.history.state
    window.history.pushState({ ...(currentState ?? {}), [marker]: true }, '', window.location.href)
    pushedRef.current = true

    const onPopState = (event: PopStateEvent) => {
      if (!pushedRef.current || event.state?.[marker]) return
      pushedRef.current = false
      onDismissRef.current()
    }

    window.addEventListener('popstate', onPopState)
    return () => {
      window.removeEventListener('popstate', onPopState)
      if (pushedRef.current && window.history.state?.[marker]) {
        pushedRef.current = false
        window.history.back()
      }
    }
  }, [marker, open])

  return useCallback(() => {
    if (typeof window !== 'undefined' && pushedRef.current && window.history.state?.[marker]) {
      window.history.back()
      return
    }
    onDismissRef.current()
  }, [marker])
}
